export const FIRM_LOGIN_SLUG_KEY = "firm_login_slug";

// Keep literal top-level routes reserved so the slug route never claims a real page.
export const RESERVED_LOGIN_SLUGS = new Set([
  "login",
  "inbox",
  "chat",
  "search",
  "treatment",
  "api",
  "landing-page",
  "work-list",
  "create-client",
  "request-access",
  "sign",
  "esign",
  "auth",
  "google_redirect_with_auth",
  "gmail_redirect_with_auth",
  "outlook_redirect_with_auth",
  "google_calendar_redirect_with_auth",
  "quickbooksredirect",
  "google_drive_redirect",
  "box_redirect",
  "dropbox_redirect",
  "msredirect",
  "mscalendarredirect",
  "msonedriveredirect",
  "gmail-oauth2callback",
  "outlook-oauth2callback",
]);

export const normalizeFirmSlug = (value) => {
  if (typeof value !== "string") return null;
  const slug = value.trim().toLowerCase();
  return /^[a-z0-9-]+$/.test(slug) && !slug.startsWith("bp-") && !RESERVED_LOGIN_SLUGS.has(slug)
    ? slug
    : null;
};

export const isFirmLoginPath = (pathname = "") => {
  const match = /^\/([^/]+)\/?$/.exec(pathname);
  return Boolean(match && normalizeFirmSlug(match[1]));
};

export const isPublicAuthPath = (pathname = "") =>
  [
    "/",
    "/landing-page",
    "/login",
    "/request-access",
    "/api/treatment-opt/activate-account",
  ].includes(pathname.replace(/\/$/, "") || "/") || isFirmLoginPath(pathname);

export const getFirmLoginPath = (value) => {
  const slug = normalizeFirmSlug(value);
  return slug ? `/${slug}` : "/login";
};

export const rememberFirmLoginSlug = (value) => {
  const slug = normalizeFirmSlug(value);
  if (slug) localStorage.setItem(FIRM_LOGIN_SLUG_KEY, slug);
  else localStorage.removeItem(FIRM_LOGIN_SLUG_KEY);
};

export const getStoredFirmLoginPath = () =>
  getFirmLoginPath(localStorage.getItem(FIRM_LOGIN_SLUG_KEY));
